import VTable from '@/vuetify_custom/v-table/v3'
import { getsafe, formattingNumber} from '@/libs/util.js'

import {account_type_hash_title, account_status_hash_title} from '@/views/fin/account_management/fields.js'
import GetLoginInfo from '@/views/fin/account_management/GetLoginInfo.jsx'
import EditModalItem from '@/views/fin/account_management/EditModalItem.jsx'
import ExpandDetail from '@/views/fin/account_management/ExpandDetail.jsx'
import ContractTip from '@/views/fin/account_management/ContractTip.vue'
const getPrive = (key) => (h, _, t) => {
    const val = getsafe(t, key, undefined)
    return h('div', {
        style: 'text-align: right'
    }, [![undefined, null, ''].includes(val) ? formattingNumber(val, 2) : '-'])
}

export default {
    props: {
        list: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: () => false
        },
        showInput: {
            type: Boolean,
            default: () => false
        },
        isFin: {
            type: Boolean,
            default: () => false
        }
    },
    computed: {
        CustomerId() {
            const cur_id = getsafe(this, '$store.state.cur_customer.id', '')
            // const customer_id = getsafe(this, 'item.customer_id')
            // `${cur_id}` === `${customer_id}` || this.isFin
           return cur_id 
        },
        table_fields() {
            return [
                {
                    expand:true,
                    z_index:2,
                },
                {
                    text: '账号编号',
                    align: 'center',
                    value: 'uid',
                    fixed: 'left',
                    z_index:2,
                    width: 120,
                },
                {
                    text: '合同编号',
                    align: 'center',
                    value: 'active_contract',
                    width: 120,
                    render:(_, target) => {
                       const contracts = getsafe(target, 'contracts', [])
                       const dis_uid = getsafe(target, 'active_contract.uid')
                     
                        if (contracts.length < 2) {
                            return <span>{dis_uid}</span>
                        }
                        return <ContractTip 
                            title={dis_uid}
                            contracts={contracts.filter(i => i.uid !== dis_uid)}
                        />
                    }
                },
                {
                    text: 'sku',
                    align: 'center',
                    value: 'consume_skus',
                    width: 180,
                    render: (val) => {
                        if (!val) {
                            return <span></span>
                        }
                        const arr = val.split(',')
                        return <div>
                            {arr.map(i => <p key={i} style="margin-bottom:0px">{i}</p>)}
                        </div>
                    }
                    // render:(values, target) => {
                    //     console.log('values', values)
                    //    const contracts = getsafe(target, 'contracts', [])
                    //    const dis_uid = getsafe(target, 'active_contract.uid')
                     
                    //     if (contracts.length < 2) {
                    //         return <span>{dis_uid}</span>
                    //     }
                    //     return <ContractTip 
                    //         title={dis_uid}
                    //         contracts={contracts.filter(i => i.uid !== dis_uid)}
                    //     />
                    // }
                },
                {
                    text: '账户类型',
                    align: 'center',
                    value: 'account_type',
                    width: 120,
                    render:(val, t) => {
                        if (!this.isFin) {
                            return <span>{getsafe(account_type_hash_title, `${val}`)}</span>
                        }
                        return <EditModalItem
                        type="type"
                        title={getsafe(account_type_hash_title, `${val}`)}
                        target ={t}
                        on={{success:() => {
                            this.$emit('getList')
                        }}}
                   /> 
                    }
                },
                {
                    text: '平台',
                    align: 'center',
                    value: 'platform_name',
                    width: 120,
                },
                {
                    text: '负责人',
                    align: 'center',
                    value: 'customer_name',
                    width: 120,
                },
                // account_status_hash_title
                {
                    text: '账户状态',
                    align: 'center',
                    value: 'account_status',
                    width: 120,
                    render:(val, t) => {
                       return <EditModalItem
                            type="account_status"
                            title={getsafe(account_status_hash_title, `${val}`)}
                            target ={t}
                            on={{success:() => {
                                this.$emit('getList')
                            }}}
                       />  
                    } 
                
                },
                {
                    text: '对方公司名称',
                    align: 'center',
                    value: 'payee_company',
                    width: 120,
                },
                {
                    text: '充值金额',
                    align: 'right',
                    value: 'acc_recharge_amount',
                    width: 120,
                    renderv: getPrive('acc_recharge_amount')
                
                },
                {
                    text: '消耗金额',
                    align: 'right',
                    value: 'acc_consume_amount',
                    width: 120,
                    renderv: getPrive('acc_consume_amount')
                },
                {
                    text: '异常变动',
                    align: 'right',
                    value: 'acc_unusual_change_amount',
                    width: 120,
                    renderv: getPrive('acc_unusual_change_amount')
                    
                },
                {
                    text: '账户余额',
                    align: 'right',
                    value: 'current_balance',
                    width: 120,
                    renderv: getPrive('active_monthly_record.current_balance')
                },
                {
                    text: '说明',
                    align: 'center',
                    value: 'remark',
                    width: 120,
                    render:(val, t) => {
                        return <EditModalItem
                             type="remark"
                             title={val}
                             target ={t}
                             on={{success:() => {
                                 this.$emit('getList')
                             }}}
                        /> 
                        
                 } 
                },
                {
                    text: '操作',
                    align: 'center',
                    fixed: 'right',
                    value: 'platform_nickname',
                    width: 120,
                    z_index:2,
                    render:(_, target) => {
                        if (target.activity && !target.virtual && !target.ams_account_id) {
                           return <span>账号同步失败（请联系开发人员）</span>
                        }
                        if (!target.ams_account_id) {
                            return <span>无登录信息</span>
                        }
                        if (!this.isFin && this.CustomerId !== getsafe(target, 'customer_id')) {
                            return <span>-</span>
                        }
                        return <GetLoginInfo target={target} id={target.ams_account_id}/>
                    }
                }
            ]
        }
    },
    render() {
        return <div>
            <VTable
                headers={this.table_fields}
                desserts={this.list}
                loading={this.loading}
                fixedHeader
                fixedHeaderZindex={3}
                scopedSlots = {{
                    expand:({item}) => {
                        return <ExpandDetail
                            showInput={this.showInput}
                         item={item}/>
                    }
                }}
            >

            </VTable>
        </div>
    }
}